export default __webpack_public_path__ + "static/media/Maidenhair-Fern_L1.3810bc5b.png";